<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<style> 
* { text-transform: none !important;}
/*
* { text-transform: none !important; color:rgb(86,106,127);} 
th {background-color:#233446; text-align:center; color:#919ead;font-size:13px; font-weight:600;letter-spacing:-0.4px;}
*/

.listHeader {background-color:#233446; text-align:center; color:#919ead;font-size:13px; font-weight:600;letter-spacing:-0.4px;}
.listHeader2 {background-color:#EDEEF0; text-align:center; color:#919ead;font-size:13px; font-weight:600;letter-spacing:-0.4px;}
td {text-align:center; font-size:13px; font-weight:400; letter-spacing:-0.4px;}
.listCnt {font-size:18px; font-weight:500;color:#696CFF}
.gnb_active {color: rgba(255,255,255,.7) !important; text-decoration: none !important; }
.gnb_non_active {color: rgba(145,158,173) !important; text-decoration: none !important; }
.gnb_list {color:#919ead; line-height: 60px;font-size:14px; font-weight:600;}
.summery_info{color:rgb(86,106,127);}
.v-input .v-label, .v-text-field { font-size: 13px !important; }
.v-pagination > li, button { font-size: 12px !important;  }

.schClearBtn {background-color:#8592A3 !important;}
.schBtn {background-color:#696CFF !important;}
.registerBtn {background-color:#696CFF !important;}
.excelBtn {background-color:#03c3ec !important;}
.backBtn {background-color:#233446 !important;}
.deleteBtn {background-color:#8592A3 !important;}

</style>
<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
